import React from 'react'
function RightSection({productName,productDescription,tryDemo,learnMore,googlePlay,appStore,imageURL}) {
    return ( 
        <div className='container mt-5 '>
            <div className='row mt-5'>
                
                
                <div className='col mt-5'>
                    <h1 className='mt-5'>{productName}</h1>
                    <p className=' mt-4 mb-4 text-muted'>{productDescription}</p>
                    <a  href={tryDemo} >Try Demo <i class="fa-solid fa-arrow-right-long"></i></a>
                    
                    <a className='mx-4'  href={learnMore}>Learn More <i class="fa-solid fa-arrow-right-long"></i></a>
                    <br />
                    
                </div>
                <div className='col'>
                    <img src={imageURL} alt={productName}
                    style={{width:"90%"}}/>
                </div>
            </div>
        </div>
     );
}

export default RightSection;